import React from 'react';

import { TextContents, WrapPosition } from './TextItem.styled';

const TextItem = props => {
  return (
    <WrapPosition pos={props.data.pos} data-html2canvas-ignore={false}>
      <TextContents
        id={props.data.id}
        addStyle={props.data.addStyle}
        fontStyle={props.data.fontStyle}
      >
        {props.data.contents}
      </TextContents>
    </WrapPosition>
  );
};

export default TextItem;



// WEBPACK FOOTER //
// ./src/components/preview/TextItem.tsx